"use strict";

exports.__esModule = true;
exports.default = _default;
function _default(ref) {
  return {
    methods: {
      focus() {
        this.$refs[ref].focus();
      }
    }
  };
}
;